import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, switchMap } from 'rxjs'; 
import { CommonService } from '../../services/common.service';
import { Attachments, DirectRetrievalDto } from '../../models/directRetrievalDto';

@Component({
  selector: 'app-direct-doc-retrieval',
  templateUrl: './direct-doc-retrieval.component.html',
  styleUrl: './direct-doc-retrieval.component.scss'
})
export class DirectDocRetrievalComponent implements OnInit {
  systemId: string | null = null;
  docId: string | null = null;
  batchId: string | null = null;
  docDetails!: DirectRetrievalDto;
  attachements: Attachments[] = [];
  constructor(
    private readonly route: ActivatedRoute,
    private readonly commonService: CommonService,
  ) { }

  ngOnInit(): void {
    // This approach handles both path params and query params
    // It will check query params first, if not found, it checks path params
    this.route.queryParamMap.pipe(
      switchMap(queryParamMap => {
        const querySysId = queryParamMap.get('sys_id');
        const queryDocId = queryParamMap.get('doc_id');
        
        if (querySysId && queryDocId) {
          // Found in query params
          this.systemId = querySysId;
          this.docId = queryDocId;
          return of(null); // Complete the observable, we found what we needed
        } else {
          // If not in query params, try path params
          return this.route.paramMap;
        }
      })
    ).subscribe(paramMap => {
      // paramMap will be null if we found query params, otherwise it's the ParamMap from path
      if (paramMap) { // Check if it's a ParamMap object
        this.systemId = paramMap.get('sys_id');
        this.docId = paramMap.get('doc_id');
      } 
    });
    this.loadPage();
  }
  loadPage(){
    this.commonService.getDirectRetrieval(this.systemId,this.docId,this.batchId).subscribe({
      next: (response:DirectRetrievalDto)=> {
        this.docDetails = response; 
      },
      error: (error) => {

      }
    })
 
  }
}